import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "218 -1 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "scale(1.04 1.35)",
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M269.78,42.39,243.14,1.5c-1.3-2-3.4-2-4.71,0L218.51,32.08l-1.15,1.76h0l-5.56,8.55c-1.3,2-.56,3.61,1.66,3.61h42.61l-6.92-10.35a4.35,4.35,0,0,0-3.2-1.8H231.42a1.12,1.12,0,0,1-.83-.34h0a.74.74,0,0,1-.13-.21.06.06,0,0,0,0,0,.78.78,0,0,1,0-.21v-.1a.68.68,0,0,1,0-.2,1.67,1.67,0,0,1,0-.18l.05-.14a2.16,2.16,0,0,1,.2-.36l8.7-13.1h0l.17-.24a1.32,1.32,0,0,1,2.38,0l.47.71h0L260.1,46h8C270.33,46,271.07,44.38,269.78,42.39Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M254.48,43.62H211.24c-.35,1.38.48,2.38,2.22,2.38h42.61Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M252.23,40.26h-39l-1.38,2.13a3.91,3.91,0,0,0-.56,1.23h43.24Z" }),
			/* @__PURE__ */ _jsx("polygon", { points: "249.99 36.91 215.37 36.91 213.18 40.26 252.23 40.26 249.99 36.91" }),
			/* @__PURE__ */ _jsx("path", { d: "M249.15,35.65a4.35,4.35,0,0,0-3.2-1.8H217.36l-2,3.07H250Z" })
		]
	})
});
export default SvgLogo;
